import React from 'react';
import { motion } from 'framer-motion';
import { Layout } from '../components/Layout';
import { StarIcon, QuoteIcon } from 'lucide-react';
const testimonials = [{
  name: 'Sarah Jenkins',
  location: 'Bowie, MD',
  text: "I couldn't believe it was the same kitchen. The team was professional, clean, and finished exactly when they said they would. Saving 50% compared to a full remodel was the best part!",
  rating: 5,
  image: 'https://i.pravatar.cc/150?u=sarah'
}, {
  name: 'Michael Chen',
  location: 'Annapolis, MD',
  text: "The precision of the refacing is incredible. You can't tell these aren't brand new custom cabinets. Highly recommend NK Refacers for anyone looking for a high-end look on a budget.",
  rating: 5,
  image: 'https://i.pravatar.cc/150?u=michael'
}, {
  name: 'Emily Rodriguez',
  location: 'Silver Spring, MD',
  text: 'Zero mess, zero stress. They worked in my home with so much respect. The results exceeded my expectations. My kitchen feels fresh and modern now.',
  rating: 5,
  image: 'https://i.pravatar.cc/150?u=emily'
}, {
  name: 'David Thompson',
  location: 'Alexandria, VA',
  text: "Honest recommendations and transparent pricing. They didn't try to upsell me on things I didn't need. The craftsmanship is top-notch.",
  rating: 5,
  image: 'https://i.pravatar.cc/150?u=david'
}];
export function TestimonialsPage() {
  return <Layout data-id="element-634">
      <section className="py-24 px-6 bg-alabaster border-b-3 border-charcoal" data-id="element-635">
        <div className="max-w-7xl mx-auto text-center" data-id="element-636">
          <motion.span initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="inline-block bg-espresso/10 text-espresso px-4 py-2 font-bold uppercase tracking-widest text-xs mb-6" data-id="element-637">
            Client Stories
          </motion.span>
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="text-5xl md:text-7xl font-bold mb-8" data-id="element-638">
            What Our{' '}
            <span className="italic font-serif font-normal text-espresso" data-id="element-639">
              Clients
            </span>{' '}
            Say.
          </motion.h1>
        </div>
      </section>

      <section className="py-24 px-6 bg-white" data-id="element-640">
        <div className="max-w-7xl mx-auto" data-id="element-641">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-642">
            {testimonials.map((t, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.1
          }} className="border-3 border-charcoal p-10 relative group hover:bg-charcoal transition-colors duration-500" data-id="element-643">
                <QuoteIcon className="absolute top-6 right-6 w-12 h-12 text-espresso/10 group-hover:text-espresso/20 transition-colors" data-id="element-644" />
                <div className="flex gap-1 mb-6" data-id="element-645">
                  {[...Array(t.rating)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-espresso text-espresso" data-id="element-646" />)}
                </div>
                <p className="text-xl text-charcoal/80 group-hover:text-alabaster/90 transition-colors mb-8 leading-relaxed italic" data-id="element-647">
                  "{t.text}"
                </p>
                <div className="flex items-center gap-4" data-id="element-648">
                  <img src={t.image} alt={t.name} className="w-12 h-12 rounded-full border-2 border-charcoal group-hover:border-alabaster transition-colors" data-id="element-649" />
                  <div data-id="element-650">
                    <h4 className="font-bold group-hover:text-alabaster transition-colors" data-id="element-651">
                      {t.name}
                    </h4>
                    <p className="text-sm text-charcoal/40 group-hover:text-alabaster/40 transition-colors" data-id="element-652">
                      {t.location}
                    </p>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>
    </Layout>;
}